export default {
  props: {
    size: {
      type: [String, Number],
      default: '150',
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
    isBlack: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    logoSrc() {
      if (this.isWhite) {
        return process.env[`VUE_APP_LOGO_2_${this.$i18n.locale.toUpperCase()}_WHITE`]
      }
      if (this.isBlack) {
        return process.env[`VUE_APP_LOGO_2_${this.$i18n.locale.toUpperCase()}_BLACK`]
      }
      return process.env[`VUE_APP_LOGO_2_${this.$i18n.locale.toUpperCase()}`]
    },
  },
}
